// Chakra imports
import {
  Box,
  Flex,
  Image,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
// Assets
import React from "react";

export default function NFT({ id, nft }) {
  const textColor = useColorModeValue("navy.700", "white");
  return (
    <Card p='20px'>
      <Flex direction={{ base: "column" }} justify='center'>
        <Box position='relative'>
          <a href={nft.url} target="_blank">
          <Image
            src={nft.url}
            w={{ base: "100%", "3xl": "100%" }}
            h={{ base: "100%", "3xl": "100%" }}
            borderRadius='20px'
            />          
            </a>
        </Box>        
      </Flex>
    </Card>
  );
}
